<template>
    
  <div style="overflow: hidden;height: 100vh;">
      <div :style="'background-image: url('+shop.ad_image+');'" style="border-radius: 15px; background-size: cover;background-position: center; background-repeat: no-repeat; height: 75px;">
      </div>
      <div class="ku-food">
          <div class="ku-tab">
              <div v-for="(item, index) in food_tab" :key="index" @click="get_list(item)" class="item" :class="item.active === 1 ? 'active' : ''">
                  <div class="name"><span>{{ item.name }}</span></div>
                  <div class="s_name"><span>{{ item.s_name }}</span></div>
                  <div class="en_name"><span>{{ item.en_name }}</span></div>
              </div>
          </div>
          <div class="ku-right-box">
              <!-- 套餐商品 -->
              <div class="ku-combo">
                  <div class="grid" v-for="(vo, key) in comboList" :key="key" v-show="click_id === vo.category_id">
                      <div class="s1" @click="addCombo(vo, $event)">
                          <span>{{ vo.name }}</span>
                          <span><label>&yen;</label>{{ vo.price }}</span>
                          <span>点击进购物车</span>
                      </div>
                      <div class="s2">
                          <div class="s-1" v-for="(item, index) in vo.list" :key="index" @click="xGoods(item, key)">
                              <van-image :src="item.price_list.image" lazy-load fit="cover" />
                              <span>{{ item.price_list.name }}</span>
                              <span>选项{{ index+1 }}</span>
                          </div>
                      </div>
                      <div class="s3" v-for="(v3, i3) in vo.list" :key="i3" v-show="v3.show">
                          <div class="back_a"></div>
                          <div class="s3-goods">
                              <div class="s-1" v-for="(v3_1, i3_1) in v3.list" :key="i3_1" @click="v3Goods(v3_1, i3, key)">
                                  <van-image :src="v3_1.image" lazy-load fit="cover" />
                                  <span>{{ v3_1.name }}</span>
                                  <van-icon name="success" v-show="v3.price_list.id === v3_1.id" />
                              </div>
                          </div>
                          <div class="v3-raise">
                              <div class="s-1" v-for="(v3_raise, i3_raise) in vo.price_list" :key="i3_raise" @click="v3GoodsRaise(v3_raise, i3_raise, key, i3)">
                                  <span :class="v3_raise.active ? 'active' : ''">{{ v3_raise.name }} {{ v3_raise.price > 0 ? parseFloat(v3_raise.price) + '元' : '' }}</span>
                              </div>
                          </div>
                          <van-button round type="primary" @click="v3.show = false">确定</van-button>
                      </div>
                  </div>
              </div>

              <!-- 商品 -->
              <div class="ku-list">
                  <div class="grid" v-for="(vo, key) in goodsList" :key="key" v-show="click_id === vo.id">
                      <div style="display: flex;flex-wrap: wrap;">
                          <div v-for="(item, index) in vo.list" :key="index" @click="addOne(item, $event)" :class="item.img === '' ? 'image_text' : ''" style="width: 50%;padding: 5px;box-sizing: border-box;">
                              <van-image :src="item.img" fit="cover" />
                              <div style="display: flex; flex-wrap: nowrap;">
                                  <span class="title" style="flex: 1;">{{ item.name }}</span>
                                  <span class="price"><label>&yen;</label>{{ item.price }}</span>
                              </div>
                          </div>
                      </div>
                  </div>

              </div>
          </div>
      </div>
      <div class="buy">
          <!-- <div class="but-1" v-if="shop.checkTime" @click="onHref(1)">特惠早餐</div> -->
          <div class="cen" @click="buy" ref="cart" v-if="goodsList.length !== 0 || comboList.length !== 0">
              <div class="cenbuyicon" >
                  <img src="../../assets/icon.png" >
              </div>
              <div class="s2">
                  <div><span style="font-size: 12px; position: relative; top: -5px;">￥</span>{{ total }}</div>
                  
              </div>
              <div class="buyBtn">去结算</div>
          </div>
          <!-- <div class="but-1" v-if="shop.checkTime">更多餐品</div> -->
      </div>

      <van-popup v-model="oneShow" class="onePop">
          <div class="back_a"></div>
          <div class="s1">{{ onePop.name }}</div>
          <div class="v3-raise">
              <div class="s-1" v-for="(vo, index) in onePop.raise" :key="index" @click="onePopActive(index)">
                  <span :class="vo.active ? 'active' : ''">{{ vo.name }} {{ vo.price > 0 ? parseFloat(vo.price) + '元' : '' }}</span>
              </div>
          </div>
          <van-button round type="primary" @click="addOneOk">确定</van-button>
      </van-popup>

      <van-popup closeable v-model="wechatShow" class="wechatPop">
          <div class="back_a"></div>
          <div class='list' v-for="(v1, k1) in wechatList" :key="k1">
              <div class="s1"><van-image :src="v1.img" lazy-load fit="cover" /></div>
              <div class="s2">
                  <span>{{ v1.name }}</span>
                  <span>{{ v1.price }}</span>
              </div>
              <van-button round type="primary" @click="addOneWechat(v1)">加入购物车</van-button>
          </div>
      </van-popup>

      <van-popup closeable v-model="hdShow" class="wechatPop">
          <div class="back_a"></div>
          <div class="wechatTop">
              <div class="k1">特惠</div>
              <div class="k2">
                  <div class='list' v-for="(v1, k1) in wechatTopList" :key="k1">
                      <div class="s3">{{ v1.price }}</div>
                      <div class="s1"><van-image :src="v1.img" lazy-load fit="cover" /></div>
                      <div class="s2">{{ v1.name }}</div>
                      <van-button round type="primary" @click="addOneWechatHd(v1)">加入购物车</van-button>
                  </div>
              </div>
              <div class="k1">每天特惠，周周不同</div>
          </div>
      </van-popup>

      <transition v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:after-enter="afterEnter">
          <div class="ball" v-show="ballFlag" v-cloak ref="ball" :style="{top: `${tt}px`,left:`${ll}px`}"></div>
      </transition>

      <van-empty v-if="showEmpty && goodsList.length === 0 && comboList.length === 0" description="当前没有可售餐品" />


      <!-- <van-popup v-model="showPopup" class="csss">
          <van-loading type="spinner" />
      </van-popup> -->

      <!--div class="switch" v-if="shop.switch === 0">
          <div class="s1"></div>
          <img src='../../assets/3.png' />
          <van-button type="primary" @click="close">关闭</van-button>
      </div-->

  </div>
</template>

<script>
import Vue from 'vue';
import {Button, Empty, Grid, GridItem, Icon, Image as VanImage, Lazyload, Loading, Notify, Popup} from 'vant';
import {getCookie, setCookie} from "@/utils/auth";

Vue.use(Grid).use(GridItem).use(VanImage).use(Button)
  .use(Notify).use(Lazyload)
  .use(Popup).use(Icon).use(Empty).use(Loading);

export default {
  name: "Goods",
  data() {
      return {
          hd: 0,
          shop_id: 0,
          shop: [],
          food_tab: [],
          coType: 1,
          tab_num: 0,
          click_id: 0,
          showEmpty: false,
          showPopup: true,

          comboList: [],
          goodsList: [],
          wechatList: [],
          wechatTopList: [],

          card: [],
          cart: [],
          total: 0,
          oneShow: false,
          onePop: [],

          tt:0,//小球因为自适应需要重新设置top值
          ll:0,
          ballFlag: false,

          wechatShow: false,
          hdShow: false,

          top: 0,
      }
  },
  mounted() {
      this.shop_id = this.$route.query.shop_id
      this.hd = this.$route.query.hd
      let that = this
      that.coType = getCookie('coType');
      let cart = getCookie('cart_' + this.shop_id) || '';
      if (cart !== 'undefined' && cart !== '') {
          let cart_time = getCookie('cart_time_' + this.shop_id)
          if (cart_time !== 'undefined' && cart_time !== '') {
              cart_time = parseInt(cart_time)
              let time = Math.round(new Date().getTime()/1000)
              if ((cart_time + 60 * 60 *10) > time) {
                  that.cart = JSON.parse(cart)
              } else {
                  that.cart = []
              }
          } else {
              that.cart = []
          }
      }

      this.getGoodComboList()

  },
  methods: {
      onHref(type) {
          if (type === 1) {
              this.$router.push('/goods_fast?shop_id=' + this.shop_id);
          }
      },
      getGoodList(one) {
          let that = this
          that.goodsList = one
          one.forEach(function (item, key) {
              if (!that.click_id) {
                  that.click_id = item.id
              }
              let arr = item.name.split('')
              let name = arr[0] + arr[1]
              let s_name = ''
              arr.forEach(function (v, k) {
                if (k > 1) {
                  s_name = s_name + v
                }
              })
              that.food_tab.push({
                  name: name,
                  s_name: s_name,
                  en_name: item.en_name,
                  id: item.id,
                  active: key ? 0 : 1
              })
              that.tab_num += 1
          })
          that.showEmpty = true
          that.showPopup = false
      },
      getGoodComboList() {
          let that = this

          this.$API.getShopInfo({shop_id: that.shop_id}).then(res => {
              return res.data
          }).then(res => {
              that.shop = res.data
              document.title = that.shop.shop_name

              this.$API.getGoodComboList({shop_id: this.shop_id}).then(res => {
                  return res.data
              }).then(res => {
                  let combo = res.data.combo
                  let one = res.data.one
                  this.wechatList = res.data.wechat
                  this.wechatTopList = res.data.wechatTop
                  that.comboList = combo
                  this.getGoodList(one)
                  if (this.wechatList.length > 0) {
                      this.wechatShow = true
                  }
                  if (this.wechatTopList.length > 0 && this.hd == 1) {
                      this.hdShow = true
                      this.wechatShow = false
                  }
              })
              that.cart.forEach(v => {
                  that.total = that.$number.numberPlus(that.total, v.price)
              })
          });
      },
      xGoods(value, index) {
          let show = !value.show
          this.allHide()
          value.show = show
          this.comboList[index].price_list = value.price_list.raise
      },
      allHide() {
          // 隐藏其他弹出
          this.comboList.forEach(v1 => {
              v1.list.forEach(function (v2) {
                  v2.show = false
              })
          })
      },
      v3Goods(vo, i3, key) {
          this.comboList[key].list[i3].price_list = vo
          this.comboList[key].price_list = vo.raise
          this.onPrice(key)
      },
      v3GoodsRaise(vo, i3_raise, key, i3) {
          this.comboList[key].price_list[i3_raise].active = !this.comboList[key].price_list[i3_raise].active
          this.comboList[key].list[i3].list.raise = this.comboList[key].price_list
          this.onPrice(key)
      },
      // 重新计算套餐价格
      onPrice(key) {
          let vo = this.comboList[key]
              , that = this
              , price = 0;
          vo.list.forEach(v1 => {
              v1.price_list.raise.forEach(vraise => {
                  if (vraise.active) {
                      price = that.$number.numberPlus(price, parseFloat(vraise.price))
                  }
              })
              price = that.$number.numberPlus(price, parseFloat(v1.price_list.price))
          })
          vo.price = that.$number.numberReduce(price, vo.discount);
      },
      addOneOk() {
          let that = this
              , raise = []
              , arr = {};
          arr.type  = 'one';
          arr.id    = that.onePop.id;
          arr.count = 1;
          arr.name  = that.onePop.name;
          arr.price = that.onePop.price;
          that.ballFlag = !that.ballFlag
          that.onePop.raise.forEach(item => {
              if (item.active) {
                  arr.price = that.$number.numberPlus(arr.price, parseFloat(item.price))
                  raise.push(item.id + '‡' + item.name + '‡' + item.price)
              }
          })
          arr.raise = raise.toString();
          if (that.cart === null) {
              that.cart = [];
          }
          that.cart.push(arr);

          that.goodsPrice()

          that.oneShow = false

          Notify({ type: 'success', message: '加入购物车成功',duration: 1000 });
      },
      addOneWechatHd(v) {
          this.hdShow = false
          this.addOneWechat(v)
      },
      addOneWechat(v) {
          let that = this
              , raise = []
              , arr = {};
          arr.type  = 'one';
          arr.id    = v.id;
          arr.count = 1;
          arr.name  = v.name;
          arr.price = v.price;
          that.ballFlag = !that.ballFlag
          v.raise.forEach(item => {
              if (item.active) {
                  arr.price = that.$number.numberPlus(arr.price, parseFloat(item.price))
                  raise.push(item.id + '‡' + item.name + '‡' + item.price)
              }
          })
          arr.raise = raise.toString();
          if (that.cart === null) {
              that.cart = [];
          }
          that.cart.push(arr);

          that.goodsPrice()

          Notify({ type: 'success', message: '加入购物车成功',duration: 1000 });
      },
      addCombo(vo, e) {
          let arr = {};
          let that = this
          , list = []
          , raise = []
          , price = parseFloat('0');
          price = that.$number.numberReduce(price, vo.discount);
          arr.type  = 'combo';
          arr.id    = vo.id;
          arr.count = 1;
          arr.name  = vo.name;

          const rect = e.target.getBoundingClientRect()
          that.tt = rect.top;
          that.ll = rect.left;
          that.ballFlag = !that.ballFlag

          vo.list.forEach(v1 => {
              raise = [];
              v1.price_list.raise.forEach(vraise => {
                  if (vraise.active) {
                      price = that.$number.numberPlus(price, parseFloat(vraise.price))
                      raise.push(vraise.id + '‡' + vraise.name + '‡' + vraise.price)
                  }
              })
              list.push({
                  id: v1.price_list.id,
                  name: v1.price_list.name,
                  raise: raise.toString()
              });
              price = that.$number.numberPlus(price, parseFloat(v1.price_list.price))
          })
          arr.price  = price
          arr.subgoods = list;

          if (that.cart === null) {
              that.cart = [];
          }
          that.cart.push(arr);

          that.goodsPrice()

          Notify({ type: 'success', message: '加入购物车成功',duration: 1000 });
      },
      goodsPrice() {
          this.total = 0;
          this.cart.forEach(v => {
              this.total = this.$number.numberPlus(this.total, v.price)
          })
          setCookie('cart_' + this.shop_id, JSON.stringify(this.cart))
          setCookie('cart_time_' + this.shop_id, Math.round(new Date().getTime()/1000))
      },
      addOne(vo, e) {
          this.onePop = vo
          const rect=e.target.getBoundingClientRect()
          this.tt = rect.top;
          this.ll = rect.left;
          if (vo.raise.length > 0) {
              vo.raise.forEach(item => {
                  item.active = false
              })
              this.oneShow = true
          } else {
              this.addOneOk()
          }
      },
      onePopActive(index) {
          let that = this
          that.onePop.raise[index].active = !that.onePop.raise[index].active
          this.oneShow = false
          this.oneShow = true
      },
      get_list(value) {
          let that = this
          console.log(value.id)
          this.click_id = value.id
          that.food_tab.forEach(function (item) {
              if (item.id === value.id) {
                  item.active = 1
              } else {
                  item.active = 0
              }
          })
          this.allHide()
          this.toTop()
      },
      toTop() {
          document.documentElement.scrollTop = this.top >= 5 ? 0 : this.top + 1;
      },
      buy() {
          if (this.cart.length === 0) {
              Notify({ type: 'danger', message: '购物车为空' });
              return false;
          }
          if (this.total < this.shop.min_fee && this.coType === '2') {
              Notify({ type: 'danger', message: '未达到起送金额' });
              return false;
          }
          setCookie('shop_id', this.shop_id)
          this.$router.push({
              path: '/cart'
          })
      },

      // 动画钩子函数
      // 进入前状态
      beforeEnter (el) {
          el.style.transform = 'translate(0,0)'
      },
      // 进入中
      enter (el, done) {
          let rect = this.$refs.cart.getBoundingClientRect();
          // 需要调用元素的offset操作,才有过渡的效果,否则会马上实现过渡
          el.style.transform = 'translate(' + (rect.left + 80 - this.ll) + 'px,' + (rect.top - this.tt) + 'px)'
          el.style.transition = "all 1s cubic-bezier(.4,-0.3,1,.68)"
          done()
      },
      // 进入后
      afterEnter () {
          this.ballFlag = !this.ballFlag
      },
      close() {
          this.$router.push({
              path: '/'
          })
      }
  },
}
</script>

<style lang="less" scoped>

.ball{
      position:absolute;
      width: 25px;
      height: 25px;
      background-color: #00f;
      border-radius:50%;
      z-index:999;
  }
.ku-food {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  height: calc(100vh - 75px);
  padding-top: 10px;
  // margin-bottom: 60px;

  .csss {
      background: none;
  }

  .ku-tab {
      width: 140px;
      background: #eeefef;
      overflow: auto;
      padding-bottom: 5rem;
      .item {
          padding:10px;
          border-radius: 15px;
          .name {
              font-size: 28px;
              color: #4e443f;
          }
          .s_name {
              font-size: 28px;
              color: #4e443f;
          }
          .en_name {
              font-size: 18px;
              color: #ad896e;
          }
          &.active {
              background: #ed9a0b;
              color: #fff;

              .name, .s_name, .en_name {
                  color: #fff;
              }
              
          }
      }
  }
  .ku-right-box {
      flex: 1;
      height: calc(100vh - 85px);
      overflow: auto;
  }
  .ku-combo {
      .grid {
          margin: 10px 0 0 0 ;
          display: block;
          height: 220px;
          position: relative;
          clear: both;
          .s1 {
              float: left;
              width: 177px;
              height: 208px;
              padding: 4px 3px;
              border: 1px solid #DD5928;
              border-radius: 5px;
              position: relative;
              span {
                  color: #DD5928;
                  text-align: center;
                  display: block;
                  float: left;
                  font-size: 26px;
                  overflow: hidden;
                  position: absolute;
                  &:nth-child(1) {
                      width: 100%;
                      height: 60px;
                      line-height: 60px;
                      text-align: center;
                      font-size: 30px;
                      top: 70px;
                  }
                  &:nth-child(2) {
                      width: 100%;
                      height: 50px;
                      line-height: 50px;
                      text-align: center;
                      font-size: 30px;
                      top: 140px;
                  }
                  &:nth-child(3) {
                      width: 72%;
                      height: 35px;
                      line-height: 35px;
                      text-align: center;
                      font-size: 20px;
                      top: 2px;
                      left: 12%;
                      color: #fff;
                      border-radius: 13px;
                      padding: 0 5px;
                      background: #baa58c;
                  }
                  label {
                      font-size: 20px;
                      margin-right: 5px;
                  }
              }
          }

          .s2 {
              float: left;
              width: 562px;
              height: 230px;
              white-space: nowrap;
              overflow-x: scroll;
              overflow-y: hidden;
              text-align: left;
              .s-1 {
                  width: 165px;
                  height: 208px;
                  display: inline-block;
                  white-space: normal;
                  position: relative;
                  border: 1px solid #231815;
                  border-radius: 5px;
                  padding: 4px;
                  margin: 0 5px;
                  span {
                      display: inline-block;
                      width: 100%;
                      text-align: center;
                      font-size: 24px;
                      color: #231815;
                      &:nth-child(3) {
                          position: absolute;
                          width: 85px;
                          height: 30px;
                          top: 2px;
                          left: 48px;
                          background: #baa58c;
                          border-radius: 13px;
                          line-height: 30px;
                          color: #fff;
                          font-size: 20px;
                      }
                  }
                  .van-image {
                      width: 165px;
                      height: 165px;
                  }
              }
          }
          .s3 {
              width: 100%;
              position: absolute;
              top: 225px;
              left: 0;
              background: none;
              z-index: 1003;
              padding-bottom: 20px;
              .s3-goods {
                  width: 100%;
                  height: 230px;
                  white-space: nowrap;
                  overflow-x: scroll;
                  overflow-y: hidden;
                  padding: 20px 0;
                  .s-1 {
                      width: 165px;
                      height: 210px;
                      display: inline-block;
                      white-space: normal;
                      position: relative;
                      border-radius: 5px;
                      padding: 6px;
                      margin: 0 5px;
                      background: #fff;
                      .van-image {
                          width: 165px;
                          height: 165px;
                      }
                      .van-icon {
                          position: absolute;
                          width: 60px;
                          height: 60px;
                          background: #DD5928;
                          text-align: center;
                          line-height: 60px;
                          border-radius: 60px;
                          font-size: 30px;
                          color: #fff;
                          left: 55px;
                          top: 55px;
                      }
                  }
              }
              .v3-raise {
                  position: relative;
                  .s-1 {
                      display: inline-block;
                      white-space: normal;
                      padding: 10px;
                      min-height: 60px;
                      span {
                          padding: 15px 20px;
                          background: #fff;
                          color: #333333;
                          border-radius: 5px;
                          font-size: 24px;
                          &.active {
                              background: #DD5928;
                              color: #ffffff;
                          }
                      }
                  }
              }
              .van-button {
                  width: 100px;
                  height: 100px;
                  font-size: 24px;
                  padding: 0;
              }
          }
      }
  }
  

  
}
.back_a {
      width: 100%;
      height: 100%;
      position: absolute;
      background: #000;
      opacity: 0.5;
  }
.onePop {
      width: 100%;
      background: none;
      .s1 {
          color: #fff;
          position: relative;
          font-size: 30px;
          border: 1px solid #DD5928;
          border-radius: 5px;
          display: inline-block;
          padding: 3px 20px;
          margin: 10px auto;
      }
      .v3-raise {
          position: relative;
          padding-top: 20px;
          .s-1 {
              display: inline-block;
              white-space: normal;
              padding: 10px;
              min-height: 60px;
              span {
                  padding: 15px 20px;
                  background: #fff;
                  color: #333333;
                  border-radius: 5px;
                  font-size: 24px;
                  &.active {
                      background: #DD5928;
                      color: #ffffff;
                  }
              }
          }
      }
      .van-button {
          width: 100px;
          height: 100px;
          font-size: 24px;
          padding: 0;
          margin: 0 10px 20px 10px;
      }
  }
  .wechatPop {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding: 20px 0 80px 0;
      background: none;
      .back_a {
          left: 0;
          top: 0;
          background: #000;
          opacity: 0.5;
      }
      .wechatTop {
          display: flex;
          flex-direction: column;
          z-index: 2;
          .k1 {
              width: 100%;
              font-size: 25px;
              height: 50px;
              color: #FFFF00;
              &:nth-child(3) {
                  position: absolute;
                  bottom: 0;
                  left: 0;
              }
          }
      }
      .list {
          display: flex;
          flex-direction: column;
          margin: 0 10px;
          width: 216px;
          .s1 {
              width: 216px;
              height: 216px;
              .van-image {
                  width: 216px;
                  height: 216px;
              }
          }
          .s2 {
              font-size: 25px;
              align-items: center;
              color: #FFFFFF;
              height: 60px;
              line-height: 60px;
              text-align: center;
          }
          .s3 {
              font-size: 80px;
              font-weight: bold;
              color: #F00;
              line-height: 85px;
          }
          .van-button {
              width: 80%;
              height: 50px;
              line-height: 50px;
              font-size: 26px;
              padding: 0;
              margin: 10px auto;
          }
      }
  }
  .ku-list {

      .grid {
          min-height: 1000px;
          padding-bottom: 5rem;
          .van-image {
              width: 100%;
              height: 200px;
              border-radius: 15px;
              overflow: hidden;
          }
          span {
              font-size: 25px;
              
              &.title {
                  width: 120px;
                  text-align: left;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
              }
              &.price {
                  
                  font-size: 29px;
                  font-family: 'Microsoft YaHei',STXihei,MingLiu,serif;
                  label {
                      font-size: 16px;
                  }
              }
          }
          .image_text {
              .van-image {
                  display: none;
              }
              span {
                  width: 100%;
                  height: 40px;
                  line-height: 40px;
                  left: 0;
                  bottom: auto;
                  overflow: hidden;
                  text-align: center;
                  &.title {
                      top: 85px;
                  }
                  &.price {
                      top: 125px;
                      bottom: auto;
                      font-weight: bold;
                  }
              }
          }
      }
  }
.buy {
      position: fixed;
      width: 100%;
      bottom: 50px;
      text-align: center;
      .but-1 {
          width: 200px;
          height: 90px;
          line-height: 90px;
          background: #D32C26;
          font-size: 36px;
          color: #fff;
          border-radius: 5px;
          margin: 0 5px;
          &:nth-child(3) {
              background: #643B15;
          }
      }
      .cen {
          margin: 0 auto;
          width: 70%;
          height: 90px;
          border-radius: 70px;
          background: #ed9a0b;
          font-size: 30px;
          color: #fff;
          display: flex;
          .cenbuyicon {
              width: 120px; position: relative;
              img {
                  width: 160px; position: absolute;bottom: 0;left: -15px;
              }
          }
          .s2 {
              flex: 1;
              font-size: 40px;
              align-self: center;
          }
          .no {
              span {
                  font-size: 32px;
                  line-height: 90px;
              }
              label {
                  display: none;
              }
          }
          .buyBtn {
              width: 90px; background: #e55626;border-radius: 70px;padding: 0 28px;height: 90px; line-height:  90px; align-self: center;
          }
      }
  }
.switch {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .s1 {
      width: 100%;
      height: 100%;
      background: #000;
      opacity: 0.8;
      position: absolute;
      left: 0;
      top: 0;
  }
  img {
      width: 300px;
      margin-top: 330px;
      position: absolute;
      z-index: 1;
  }
  /deep/ .van-button {
      position: absolute;
      top: 660px;
      border-radius: 50px;
      width: 250px;
  }
}
</style>
